import { AfterViewInit, Component, ChangeDetectorRef, Injectable, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ExceptionHelper } from './../../../../helper';

import { UserSummaryService } from './user-summary.service';
import { TeamSummaryService } from '../team-summary.service';

import * as $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4';

@Component({
  selector: 'app-user-summary',
  templateUrl: './user-summary.component.html'
})

@Injectable()
export class UserSummaryComponent implements AfterViewInit, OnInit {
  activateCheckboxStatus: number;
  @ViewChild('suspended') private suspendedCheckbox: ElementRef;

  users: any[];
  teams: any[];
  dataTable: any;

  constructor(
    private exception: ExceptionHelper,
    private translate: TranslateService,
    private userSummaryService: UserSummaryService,
    private teamSummaryService: TeamSummaryService,
    private chRef: ChangeDetectorRef
  ) {
    translate.setDefaultLang('en-us');
  }

  ngAfterViewInit() {
    this.getSummary();
  }


  ngOnInit() {

  }

  apply() {
    this.getSummary();
  }

  checkboxStatus(input) {
    this.activateCheckboxStatus = input.activateCheckboxStatus;
  }

  getSummary() {
    this.teamSummaryService.getSummary()
      .subscribe((data: any) => {
        this.teams = data;
        this.userSummaryService.getSummary(this.activateCheckboxStatus, this.suspendedCheckbox.nativeElement.checked? 1 : 0)
          .subscribe((userData: any) => {

            if ($.fn.dataTable.isDataTable('#usersDataTables')) { $('#usersDataTables').DataTable().destroy(); }
            this.users = userData.userListModel;
            this.chRef.detectChanges();

            const table: any = $('#usersDataTables');
            this.dataTable = table.DataTable();
        }, error => {
          this.exception.showError(error, 'showDanModalBtn');
        });

    }, error => {
      this.exception.showError(error, 'showDanModalBtn');
    });
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/user/user-summary/user-summary.component.ts